
export default
	computed:
		hasTopBorder: -> @$store.state.tower?.darkLastBlock
		classes: -> ["top-border" if @hasTopBorder]

